import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { AdminBillingCatalogKey } from './billing.i18n.js';
import { ADMIN_BILLING_CATALOG } from './billing.i18n.js';

export type AdminBillingMessageId = `adminBilling:${AdminBillingCatalogKey}`;

const PREFIX_LENGTH = 'adminBilling:'.length;

/** `t()` for the stop-gap `adminBilling:` scope (see `billing.i18n.ts`). */
export function useBillingT(): { t: (id: AdminBillingMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: AdminBillingMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as AdminBillingCatalogKey;
      const raw = ADMIN_BILLING_CATALOG[locale][key] ?? ADMIN_BILLING_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
